// Google Analytics helper functions

export const GA_TRACKING_ID = 'G-L7PPDBWJLF';

// Track page views
export const pageview = (url) => {
  if (typeof window.gtag === 'function') {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// Track events
export const event = ({ action, category, label, value }) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Specific event tracking functions
export const trackUserSignup = (method = 'email') => {
  event({
    action: 'sign_up',
    category: 'engagement',
    label: method,
  });
};

export const trackUserLogin = (method = 'email') => {
  event({
    action: 'login',
    category: 'engagement',
    label: method,
  });
};

export const trackPlantAdded = (plantName) => {
  event({
    action: 'add_plant',
    category: 'plants',
    label: plantName,
  });
};

export const trackPlantWatered = (plantName) => {
  event({
    action: 'water_plant',
    category: 'plants',
    label: plantName,
  });
};

export const trackPlantDeleted = (plantName) => {
  event({
    action: 'delete_plant',
    category: 'plants',
    label: plantName,
  });
};

export const trackNoteAdded = (plantName) => {
  event({
    action: 'add_note',
    category: 'engagement',
    label: plantName,
  });
};